import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep10 = (state) => state.get('step10');

const makeSelectStep10 = () =>
  createSelector(selectStep10, (step10State) => ({
    areYouClaimingForSnowSportsOptionalCover: mapWithDefault(
      step10State,
      () =>
        step10State.getIn(['form', 'areYouClaimingForSnowSportsOptionalCover']),
      ''
    ),
    areYouClaimingForSnowSportEquipment: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'areYouClaimingForSnowSportEquipment']),
      ''
    ),
    areYouClaimingForSnowEquipmentReplacementHire: mapWithDefault(
      step10State,
      () =>
        step10State.getIn([
          'form',
          'areYouClaimingForSnowEquipmentReplacementHire',
        ]),
      ''
    ),
    areYouClaimingForSnowPrepaidExpenses: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'areYouClaimingForSnowPrepaidExpenses']),
      ''
    ),
    areYouClaimingForSnowResortClosure: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'areYouClaimingForSnowResortClosure']),
      ''
    ),
    // howItHappened: mapWithDefault(step10State, () => step10State.getIn(['form', 'howItHappened']), ''),
    // whereYouWereInRelationToTheItem: mapWithDefault(step10State, () => step10State.getIn(['form', 'whereYouWereInRelationToTheItem']), ''),
    // additional: mapWithDefault(step10State, () => step10State.getIn(['form', 'additional']), ''),
    // claimingFor: mapWithDefault(step10State, () => step10State.getIn(['form', 'claimingFor']).toJS(), ''),
    // whoDidYouReportThisTo: mapWithDefault(step10State, () => step10State.getIn(['form', 'whoDidYouReportThisTo']), ''),
    // otherDescription: mapWithDefault(step10State, () => step10State.getIn(['form', 'otherDescription']), ''),
    // reportReferenceNumber: mapWithDefault(step10State, () => step10State.getIn(['form', 'reportReferenceNumber']), ''),
    patientName: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'patientName']),
      ''
    ),
    relationshipToYou: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'relationshipToYou']),
      ''
    ),
    patientDateOfBirth: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'patientDateOfBirth']),
      ''
    ),
    medicareNumber: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'medicareNumber']),
      ''
    ),
    whatIsYourInjuryOrIllness: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'whatIsYourInjuryOrIllness']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivity: mapWithDefault(
      step10State,
      () =>
        step10State.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivity',
        ]),
      ''
    ),
    wasTheInjuredIllTravellerAnInpatient: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'wasTheInjuredIllTravellerAnInpatient']),
      ''
    ),
    snowPrepaidCancellationExpenses: mapWithDefault(
      step10State,
      () =>
        step10State.getIn(['form', 'snowPrepaidCancellationExpenses']).toJS(),
      ''
    ),
    snowResortCancellationExpenses: mapWithDefault(
      step10State,
      () =>
        step10State.getIn(['form', 'snowResortCancellationExpenses']).toJS(),
      ''
    ),
    snowPrepaidAdditionalExpenses: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'snowPrepaidAdditionalExpenses']).toJS(),
      ''
    ),
    snowResortAdditionalExpenses: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'snowResortAdditionalExpenses']).toJS(),
      ''
    ),
    snowSportEquipmentAdditionalItems: mapWithDefault(
      step10State,
      () =>
        step10State.getIn(['form', 'snowSportEquipmentAdditionalItems']).toJS(),
      []
    ),
    snowEquipmentReplacementHireAdditionalItems: mapWithDefault(
      step10State,
      () =>
        step10State
          .getIn(['form', 'snowEquipmentReplacementHireAdditionalItems'])
          .toJS(),
      []
    ),
    snowSportEquipment: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'snowSportEquipment']).toJS(),
      ''
    ),
    snowEquipmentReplacementHire: mapWithDefault(
      step10State,
      () => step10State.getIn(['form', 'snowEquipmentReplacementHire']).toJS(),
      ''
    ),
    areThereAnyAdditionalExpensesToBeClaimedSnowPrepaid: mapWithDefault(
      step10State,
      () =>
        step10State.getIn([
          'form',
          'areThereAnyAdditionalExpensesToBeClaimedSnowPrepaid',
        ]),
      ''
    ),
    areThereAnyAdditionalExpensesToBeClaimedSnowResort: mapWithDefault(
      step10State,
      () =>
        step10State.getIn([
          'form',
          'areThereAnyAdditionalExpensesToBeClaimedSnowResort',
        ]),
      ''
    ),
  }));

const makeSelectStep10Errors = () =>
  createSelector(selectStep10, (state) => state.get('errors'));

export { makeSelectStep10, makeSelectStep10Errors };



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step10/selectors.js